import { PaletteType } from '@/types/cinematics'

export const generateColorStyles = (palette: PaletteType) => {
  let cssVariables = ''

  for (const [category, shades] of Object.entries(palette)) {
    for (const [key, value] of Object.entries(shades)) {
      if (key.startsWith('@')) continue
      cssVariables += `--${category}-${key}: ${value};\n`
    }
  }

  return cssVariables
}